// extracted by mini-css-extract-plugin
export default {"title":"PanelTitle_title__jJAIs"};